import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useExtendedRoutesStore = create(persist((set) => ({
    records: {},
    setRecord: (id, record) => {
        set((state) => ({ records: { ...state.records, [id]: record } }));
    },
    removeRecord: (id) => {
        set((state) => {
            const { [id]: _removed, ...rest } = state.records;
            return { records: rest };
        });
    },
}), {
    name: 'extendedRoutes',
    storage: createJSONStorage(() => localStorage),
}));
